// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ctaButton":"_2eYWuD"};